export enum PreferenceKey {
  HAS_DISPLAYED_STORES_PANEL_WHEN_HAD_INTENT = 'didDisplayedStoresPanelWhenHadIntent',
  DID_SILENT_INSTALL_STORES_WHEN_HAD_INTENT = 'didSilentInstallStoresWhenHadIntent',
}
